/* eslint-disable @typescript-eslint/no-explicit-any */
import { runStaticQuery } from 'src/api/query/run.staticQuery';
import { toast } from 'src/utils/notification';

export const hashExists = async (upload: any, hash: string) => {
  return await runStaticQuery('getFileByHash', { upload: upload, hash: hash })
    .then(
      fileNode => {
        return fileNode.exists;
      }
    )
    .catch((error) => {
      toast.error('', error.message);
    });
};
  